import PropTypes from 'prop-types';
import { forwardRef } from 'react';
// @mui
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';


// ----------------------------------------------------------------------

const Logo = forwardRef(({ large = false, sx, ...other }, ref) => {
  const theme = useTheme();

  const logo = (
    <Box component="img" src="/logo/Logo.png" sx={{ width: '90%', cursor: 'pointer', ...sx }} />
  );

  const logoSquare = <Box component="img" src="/logo/Logo.png" sx={{ width: 60, height: 60, objectFit: 'contain', mt: 2, ml: 3 }} />;

  if (large) {
    return <>{logo}</>;
  }

  return logoSquare;
});

Logo.propTypes = {
  small: PropTypes.bool,
  large: PropTypes.bool,
  sx: PropTypes.object,
};

export default Logo;
